const officeUrls = {
    fetchOffices: {
        url: '/office/'
    },
    fetchOffice: {
        url: '/office/:id'
    },
    fetchOfficeEVents: {
        url: '/office/:id/events'
    },
    fetchFormOptions: {
        url: '/office/actions/formOptions'
    },
    fetchAddressAtes: {
        url: '/address-register/keyAtesh'
    },
    fetchAddressStreetsByKeyAtesh: {
        url: '/address-register/streetsByKeyAtesh'
    },
    fetchAddressFullName: {
        url: '/address-register/fullName/'
    },
    fetchAddressByLevel: {
        url: '/address-register/estate'
    },
    
    checkTiming: {
        url: '/office/:id/checkTiming'
    }
};
export default officeUrls;